module.exports = __webpack_public_path__ + "media/images/tipping-8016a513e0f1f42a5a6585d9695a8fe7.jpeg";